//Archivo dedicado al menu de todos los imports de SICPE

//Imports relacionados de SICPE
//-----------Principal-----------
import Plantilla from '@/components/SICPE/Comun/Plantilla.vue';
import Registro from '@/components/SICPE/Administracion/Registro.vue';
import Consulta from '@/components/SICPE/Administracion/Consulta.vue';
import ResolucionAmparo from '@/components/SICPE/Administracion/ResolucionAmparo.vue';
import Sicpe from '../store/SICPE';


//Se crea la lista de paths
const SICPE = [{
  path: '/SICPE/',
  component: Plantilla,
  meta: {
    RequiereAutenticacion: true,
    ValidaSesion: true,
    ObtenDatos: true,
    ObtenPermisosDelSistema: true,
    SistemaQueSeIngreso: 37
  },
  children: [{
    name: 'Registro',
    path: 'Registro',
    component: Registro,
    meta: {
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 37,
      ModuloId: 1,
      FuncionId: 1
    },
    props: true
  },
  {
    name:'Consulta',
    path: 'Consulta',
    component: Consulta,
    meta: {
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 37,
      ModuloId: 1,
      FuncionId: 4
    },
    props: true
  },
  {
    name: 'ResolucionAmparo',
    path: 'ResolucionAmparo/:folio',
    component: ResolucionAmparo,
    meta: {
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 37,
      ModuloId: 1
    },
    props: true
  }]
}];

//Se regresa la lista de paths
export default SICPE;



// WEBPACK FOOTER //
// ./src/router/SICPE.js